import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./utils/registerServiceWorker";

// import { applyProductTheme } from "./utils/applyProductTheme"; // DISABLED: Causing color issues

// Apply product theme BEFORE React render
// applyProductTheme(); // DISABLED: Using static theme from index.css

const FallbackComponent = () => (
  <div className="flex items-center justify-center min-h-screen p-4 bg-background text-foreground">
    <div className="text-center max-w-md">
      <h1 className="mb-4 text-2xl font-bold">Ops! Algo deu errado.</h1>
      <p className="mb-6 text-muted-foreground">
        Nossa equipe técnica já foi notificada e estamos trabalhando nisso para resolver o mais rápido possível.
      </p>
      <button 
        onClick={() => window.location.reload()} 
        className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90"
      >
        Tentar Novamente
      </button>
    </div>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
    <App />
  </Sentry.ErrorBoundary>
);

// Register service worker for PWA
registerServiceWorker();
